import PropTypes from 'prop-types';
import React from 'react';
import { getCurrentServiceURL } from '../utils/commons';

const addCompanyIdToUrl = (url, companyId, hasToShowCompanyInUrl) => {
  if (!companyId) return url;
  if (!hasToShowCompanyInUrl) return url;

  if (url.indexOf('?') === -1) {
    return url + '?company_id=' + companyId;
  }
  return url + '&company_id=' + companyId;
};

const getItemURL = (item, companyId) => {
  return addCompanyIdToUrl(
    getCurrentServiceURL(item.service) + item.path,
    companyId,
    item.hasToShowCompanyInUrl
  );
};

const DropdownItem = ({ item, isActive, toggle, companyId }) => (
  <li
    id={`${item.service}-${item.key}`}
    className={`${isActive ? 'active' : ''}`}
    data-service={item.service}
    data-key={item.key}
  >
    <a data-bypass={true} href={getItemURL(item, companyId)} onClick={toggle} title={item.title}>
      {item.title}
    </a>
  </li>
);

DropdownItem.propTypes = {
  item: PropTypes.shape({
    key: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    service: PropTypes.string.isRequired,
    hasToShowCompanyInUrl: PropTypes.bool,
  }).isRequired,
  isActive: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  companyId: PropTypes.string,
};

export default DropdownItem;
